import { LinearScale } from '@mui/icons-material';
import { Stack, Box } from '@mui/material';
import { makeColorDarker } from '../../utils/colors'
import { CustomTooltip } from '../CustomTooltip';

export const ChartLegend = ({ 
  payload,
  components,
  toggleBarVisibility,
  handleLegendMouseEnter,
  handleLegendMouseLeave,
  hover,
  fields,
  enableTooltip=true
}) => {

  const renderItem = (entry) => {
    return (
      <Box
        sx={{
          alignItems: 'center',
          borderColor: hover == entry.value ?
            fields[entry.value] ?
              makeColorDarker(entry.color, 80)
            : 'gray'
          : 'transparent',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderRadius: 1,
          display: 'flex',
          gap: "4px",
          padding: "4px",
          '&:hover': {
            cursor: 'pointer'
          }
        }}
        onMouseEnter={() => {
          handleLegendMouseEnter(entry.value);
        }}
        onMouseLeave={() => {
          handleLegendMouseLeave();
        }}
      >
        <Box
          sx={{
            backgroundColor: fields[entry.value]?entry.color:'gray',
            borderRadius: '4px',
            height: '15px',
            width: '15px',
          }}
        />
        <Box
          sx={{
            color: fields[entry.value] ? 'black' : 'gray',
            fontWeight: 500,
          }}
        >
          {entry.value}
        </Box>
      </Box>
    )
  }

  return (
    <Box mt={2} mb={1}>
      <Stack
        direction="row"
        justifyContent="center"
        flexWrap="wrap"
      >
        {
          payload.map((entry, index) => {
            if (entry.value === "total") {
              return (
                <Box
                  key={`item-${index}`}
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    '&:hover': {
                      cursor: 'pointer'
                    }
                  }}
                  onClick={() => toggleBarVisibility(entry.value)}
                  onMouseEnter={() => handleLegendMouseEnter(entry.value)}
                  onMouseLeave={() => handleLegendMouseLeave()}
                >
                  <LinearScale
                    fontSize='small'
                    style={{color:fields[entry.value]?'black':'gray'}}
                  />
                  <Box
                    sx={{
                      color: fields[entry.value] ? 'black' : 'gray',
                      fontWeight: 500,
                      textTransform: 'capitalize',
                    }}
                  >
                    {entry.value}
                  </Box>
                </Box>
              )
            }

            if (enableTooltip) {
              return (
                <CustomTooltip
                  key={`item-${index}`}
                  placement="top"
                  title={components[entry.value]?.label}
                  maxWidth={400}
                  onClick={() => toggleBarVisibility(entry.value)}
                >
                  {renderItem(entry)}
                </CustomTooltip>
              )
            }
            else {
              return (
                <Box key={`item-${index}`} onClick={() => toggleBarVisibility(entry.value)}>
                  {renderItem(entry)}
                </Box>
              )
            }
          })
        }
      </Stack>
    </Box>
  );
}

